module.exports = __webpack_public_path__ + "img/share.606f20d1.svg";